export default {
  field: {
    location_1: "Miaoli Shitan",
    name_1: "Chih Hu Farm",
    address_1:
      "No. 18, Baishou, Shitan Township, Miaoli County 354 , Taiwan (R.O.C.)",

    location_2: "Taoyuan Longtan",
    name_2: "Taoyuan City Hakka Culture Park",
    address_2:
      "No. 500, Sec. Sanlin, Zhongzheng Rd., Longtan Dist., Taoyuan City 325 , Taiwan (R.O.C.)",

    location_3: "Hsinchu Emei",
    name_3: "Xie Xin Tea House",
    address_3: "No. 60-8, Hsinchu County, Emei Township 315, Taiwan (R.O.C.)",

    location_4: "Hsinchu Emei",
    name_4: "12 Liao Recreation Farm",
    address_4:
      "No. 21, Shi'erliao, Emei Township, Hsinchu County 315 , Taiwan (R.O.C.)",

    location_5: "Miaoli Gongguan",
    name_5: "Tung Lodge",
    address_5:
      "No. 35-3, Fude, Gongguan Township, Miaoli County 363 , Taiwan (R.O.C.)",

    location_6: "Miaoli Sanyi",
    name_6: "Zhuo Ye Cottage",
    address_6:
      "No. 1-9, Bengshanxia, Sanyi Township, Miaoli County 367 , Taiwan (R.O.C.)",

    location_7: "Taichung Dongshi",
    name_7: "Hakka Culture Park",
    address_7:
      "No. 1, Zhongshan Rd., Dongshi Dist., Taichung City 423 , Taiwan (R.O.C.)",

    location_8: "Changhua Fenyuan",
    name_8: "Wonder Park",
    address_8:
      "No. 167, Zhongshan Rd., Fenyuan Township, Changhua County 502 , Taiwan (R.O.C.)",

    location_9: "Nantou Puli",
    name_9: "New Era Art Resort & Spa ",
    address_9:
      "No. 1, Sec. 4, Zhongshan Rd., Puli Township, Nantou County 545 , Taiwan (R.O.C.)",

    location_10: "Miaoli Tongluo",
    name_10: "Tung Flower Park",
    address_10:
      "No. 15, Longquan, Tongluo Township, Miaoli County 366 , Taiwan (R.O.C.)",

    location_11: "Hsinchu Xinpu",
    name_11: "Xinpuson Villa",
    address_11: "No. 38, Ln. 752, Xinlong Rd., Xinpu Township, Hsinchu County 305 , Taiwan (R.O.C.)",

    location_12: "Miaoli Touwu",
    name_12: "Lupine Leisure Farm",
    address_12: "No. 21, Renlong, Touwu Township, Miaoli County 362 , Taiwan (R.O.C.)",

    location_13: "Miaoli Tongxiao",
    name_13: "Santend Coffee",
    address_13: "No. 93-1, Fuxing, Tongxiao Township, Miaoli County 357 , Taiwan (R.O.C.)",

    location_14: "Hsinchu Guanxi",
    name_14: "Mawudu Discovery Forest",
    address_14: "No. 138-3, Jinshan, Guanxi Township, Hsinchu County 306, Taiwan (R.O.C.)",

    location_15: "Taitung Luye",
    name_15: "Old Railway Tung Flower Trail",
    address_15: "",

    location_16: "Miaoli Tongluo",
    name_16: "Taiwan Hakka Museum",
    address_16: "No. 6, Tongke S. Rd., Tongluo Township, Miaoli County 366 , Taiwan (R.O.C.)",

    location_17: "Miaoli Zaoqiao",
    name_17: "Jiantan Historic Trail",
    address_17: "",

    location_18: "Chiayi City",
    name_18: "Happy Hill",
    address_18: "No. 52-1, Ln. 566, Dongyi Rd., East Dist., Chiayi City 600 , Taiwan (R.O.C.)",

    location_19: "Hualien Ji'an",
    name_19: "Nanhua Forestry Culture Park",
    address_19: "No. 117, Sec. 6, Ji'an Rd., Ji’an Township, Hualien County 973 , Taiwan (R.O.C.)",

    location_20: "Hsinchu Hengshan",
    name_20: "Big Hill North Moon",
    address_20: "No. 80, Dashanbei, Hengshan Township, Hsinchu County 312 , Taiwan (R.O.C.)"
  },

  menu: {
    language: "Language",
    flowering_map: "Map of Tung Blossom",
    main_platform_name: "Hakka Tour",
    header_platform_name: "{year_en} Tung Blossom Forecast",
    platform_name: "Tung Blossom Forecast",
    // banner_description: "{year_en} Tung Blossom Information & Forecast (Forecast Updates Starting April 1, {year_en})",
    banner_description: "{year_en} Tung Blossom Information & Forecast (Flowering Period Ended)",
    go_to_top: "TOP",

    north: "Northern Taiwan",
    central: "Central Taiwan",
    south: "Southern Taiwan",
    east: "Eastern Taiwan",

    stage_bud: "Bud Stage",
    stage_flowering: "Flowering",
    stage_blossoming: "Blossoming",
    stage_wither: "The End",
    map_of_taiwan: "Map of Taiwan",
    data_source: "Sources",
    CWB_stations: "Central Weather Bureau",
    CWB_forecast: "7-day Forecasts from Central Weather Bureau",
    forecast: "7-day Forecasts",
    uv_info: "UV",
    realtime_data: "Latest Data",
    updated_at: "Latest Update",
    line_group: "LINE Group of Latest Tung Blossom Information",
    join_line_group_description:
      "Join Line Group to Acquire The Latest Tung Blossom Information",
    line_group_button_for_phone: "Mobile Phone Please Click Here",
    traffic: "Traffic Information",
    info_description:
      "Tung blossom forecast is based on modelling of on-site environmental data and historical blooming. Weather data are incorporated to provide updated blossom forecast on a rolling basis",
    info_description2:
      "In 2023, there are 20 monitoring equipments have been built in 9 counties and cities including Taoyuan, Hsinchu, Miaoli, Taichung, Changhua Chiayi, Hualien and Taitung.",
    info_update: "Latest Update Time",
    info_source:
      'The information provided is co-developed by <a href="https://www.hakka.gov.tw" target="blank">Hakka Affairs Council</a> and <a href="https://www.agriweather.online" target="blank">AgriWeather</a>',
    recommand_link:
      'Recommended Website: <a href="https://www.cwa.gov.tw/V8/C/L/Hakka/index.html" target="blank">Central Weather Bureau</a>, <a href="https://recreation.forest.gov.tw" target="blank">Taiwan Forest Recreation</a>'
  },

  sensor: {
    air_temperature: "Temperature",
    u_air_temperature: "℃",
    air_humidity: "Humidity",
    u_air_humidity: "%",

    rainfalls: "Rainfalls (24 hour)",
    u_rainfalls: "mm",
    rain_rate: "Rain Rate",
    u_rain_rate: "mm/hr",
    wind_speed: "Wind Speed",
    u_wind_speed: "m/s",
    solar_radiation: "Light Intensity",
    u_solar_radiation: "W/m<sup>2</sup>"
  }
};
